enum EditorActions {
    RESET = 'editor/RESET',
}

export { EditorActions };
